import { render, staticRenderFns } from "./InvestidoresTable.vue?vue&type=template&id=2f5be642&scoped=true"
import script from "./InvestidoresTable.vue?vue&type=script&lang=js"
export * from "./InvestidoresTable.vue?vue&type=script&lang=js"
import style0 from "./InvestidoresTable.vue?vue&type=style&index=0&id=2f5be642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5be642",
  null
  
)

export default component.exports